import styled, {ThemeProvider} from 'styled-components';
import {Job, JobCategory, StyledBaseProps} from "@betrue/shared/interfaces";
import {theme} from "@betrue/ui";
import {Grid} from "@mui/material";
import React from "react";
import {JobCategoryItemView, JobItemView} from "./job-category-item.view";


export interface JobCategoriesViewProps extends StyledBaseProps {
  jobCategories: JobCategory[],
  onCategorySelected:(jc:JobCategory) => void
}

export const JobCategoriesView = styled((props: JobCategoriesViewProps) => (
  <ThemeProvider theme={theme}>
    <Grid className={props.className} container spacing={3} alignItems={"stretch"}>
      {props.jobCategories.map((jc) => (
        <Grid key={jc.id} item xs={6} sm={4}>
          <JobCategoryItemView  onCategorySelected={props.onCategorySelected}  jobCategory={jc}/>
        </Grid>
      ))}
    </Grid>
  </ThemeProvider>
))`
  & ${JobCategoryItemView} {
    height: 100%;

    > button {
      height: 100%;
    }
  } `

export interface JobItemsViewProps extends StyledBaseProps {
  jobs: Job[]
  onJobSelect: (job:Job) => void
}

export const JobItemsView = styled((props: JobItemsViewProps) => (
  <span className={props.className}>
    {props.jobs.map(job => (<JobItemView onJobSelect={props.onJobSelect} job={job}/>))}
  </span>
))``
